import { FC } from "react";

const ArrowDeposit: FC = () => {
  return (
    <svg width="10" height="12" viewBox="0 0 10 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M4.66797 8.66862V0.667969"
        stroke="#1E2939"
        stroke-width="1.33333"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M1.23828 5.23828L4.66713 8.66713L8.09598 5.23828"
        stroke="#1E2939"
        stroke-width="1.33333"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M8.66862 10.9531H0.667969"
        stroke="#1E2939"
        stroke-width="1.33333"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export default ArrowDeposit;
